<template>
  <WizardStep v-bind="$attrs"
    :show-delay="500"
    :transition="transition"
    @move-back="transition = 'fade-right'"
    @move-forward="transition = 'fade-left'"
  >
    <slot></slot>

    <template #actions="{ isLastStep }">
        <div class="d-flex flex-row-reverse justify-content-between mt-5">
          <span>
            <NextButton
              :class="[
                'btn btn-lg',
                isLastStep ? 'btn-accent-warm btn-thick btn-grow' : 'btn-primary'
              ]"
            >{{ isLastStep ? 'Submit' : 'Next' }}</NextButton>
          </span>
          <span>
            <BackButton class="btn btn btn-lg btn-outline-primary" />
          </span>
        </div>
    </template>
  </WizardStep>
</template>

<script>
import BackButton from '@ssi/vue-common/src/components/formWizard/BackButton';
import NextButton from '@ssi/vue-common/src/components/formWizard/NextButton';
import WizardStep from '@ssi/vue-common/src/components/formWizard/WizardStep';

export default {
  components: { BackButton, NextButton, WizardStep },

  data: () => ({
    transition: 'fade-left'
  })
};
</script>
